import { DynamicFieldGroup } from "@/components/DynamicFieldInput";

/**
 * Renders Settings-driven conditional fields for the New Ticket form.
 * Hidden entirely when no fields are visible for the current context.
 */
export default function DynamicFieldsSection({ fields, values, setValue, errors = {} }) {
  if (!fields || fields.length === 0) return null;
  return (
    <div data-testid="dynamic-fields-section">
      <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-3">
        Additional Details
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {fields.map((d) => (
          <DynamicFieldGroup
            key={d.key}
            def={d}
            value={values[d.key]}
            onChange={(v) => setValue(d.key, v)}
            error={errors[`cf_${d.key}`]}
          />
        ))}
      </div>
    </div>
  );
}
